var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" Wpisz nazwę miejscowości, oraz ew. ulicę i nr domu. ")]),_c('input',{ref:"searchBox",staticClass:"search-box",attrs:{"type":"text","placeholder":"Szukaj adresu"}})])}
var staticRenderFns = []

export { render, staticRenderFns }